/**
 * TV / kiosk açılışı (#570): `/?dashboard=<id>[,<id>…]&rotate=60&fullscreen=1`.
 * Kabuk (menü, sekmeler, başlık) hiç çizilmez; panolar tam sayfa, sırayla döner.
 * Tarayıcı `--kiosk` ile açıldıysa zaten tam ekrandır; `fullscreen=1` yalnız dener.
 */
export interface KioskParams {
  ids: string[];
  rotateSec: number;
  fullscreen: boolean;
}

export const DEFAULT_ROTATE_SEC = 60;

export function parseKioskParams(search: URLSearchParams): KioskParams | null {
  const raw = search.get('dashboard');
  if (!raw) return null;
  const ids = raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
  if (!ids.length) return null;
  const rotate = Number(search.get('rotate'));
  return {
    ids,
    rotateSec: Number.isFinite(rotate) && rotate >= 10 ? Math.floor(rotate) : DEFAULT_ROTATE_SEC,
    fullscreen: search.get('fullscreen') === '1' || search.get('fullscreen') === 'true',
  };
}

/** Sıradaki pano dizini (tek panoda hep 0). */
export function nextIndex(current: number, count: number): number {
  return count > 0 ? (current + 1) % count : 0;
}
